<template>
  <div class="booking-calendar dt-page">
    <div class="top-bar">
      <div class="normal-filters">
        <div class="add-button">
          <img
            @click="onAddBookingClicked"
            class="dt-icon"
            src="static/buttons/add.svg"
            alt
          />
        </div>
        <div class="month-navigation">
          <img
            @click="previousMonthClick"
            class="dt-icon v5 s1"
            src="static/icons/arrows/chevron-left.svg"
            alt
          />
          <!-- <button class="dt-button icon left-button">
          </button>-->
          <img
            @click="nextMonthClick"
            class="dt-icon v5 s1"
            src="static/icons/arrows/chevron-right.svg"
            alt
          />
          <!-- <button class="dt-button icon right-button">
          </button>-->
        </div>
        <Dropdown
          :options="i18nMonthsTV"
          v-if="i18nMonthsTV && i18nMonthsTV.length > 0"
          :selected="i18nMonthsTV.find((e) => e.value == filter.selectedMonth)"
          :placeholder="$t('month')"
          v-on:selectedChange="(e) => onDropdownChange('month', e)"
          :style="{ maxWidth: '160px', width: '160px !important' }"
        />
        <Dropdown
          :options="artistsTV"
          v-if="artists && artists.length > 0"
          :selected="
            artistsTV.filter((a) => filter.selectedArtists.includes(a.value))
          "
          :placeholder="$t('select_all_project')"
          multiple
          allnone
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('artist', e)"
          :listHeight="600"
        />
        <Dropdown
          :options="staffs"
          v-if="staffs && staffs.length > 0"
          :selected="
            staffs.filter((e) => filter.selectedStaffs.includes(e.value))
          "
          :placeholder="$t('select_all_staff')"
          multiple
          allnone
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('Staff', e)"
        />
        <button
          class="dt-button s0 filter-bar-button ut-cap"
          @click="onTodayClick"
        >
          {{ $t("today") }}
        </button>

        <v-menu offset-y class="bl-more-menu">
          <button class="dt-button s0 filter-bar-button" slot="activator">
            <v-icon>more_horiz</v-icon>
          </button>
          <v-list class="filter-more-options-list">
            <v-list-tile
              class="options-item"
              v-for="(item, index) in dropdownItems"
              :key="index"
              @click="(e) => onMenuItemClicked(item)"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <div class="status-selection-container">
          <div class="max-min-button">
            <img
              v-if="!statusSelMaximized"
              @click="maximizeSelectionContainer"
              class="dt-icon v5 s1"
              src="static/icons/arrows/chevron-down.svg"
              alt
            />
            <img
              v-if="statusSelMaximized"
              @click="minimizeSelectionContainer"
              class="dt-icon v5 s1"
              src="static/icons/arrows/chevron-up.svg"
              alt
            />
          </div>
          <div class="status-selection">
            <div
              class="status-item"
              v-for="status of statusesTT"
              :key="status.value"
            >
              <div class="status-checkbox">
                <div class="dt-checkbox v2">
                  <input
                    type="checkbox"
                    :name="status.value"
                    :id="status.value"
                    :title="status.text"
                    :checked="filter.selectedStatuses.includes(status.value)"
                    @click="(e) => onStatusSelected(e, status)"
                  />
                  <div
                    class="checkmark"
                    :style="{
                      backgroundColor: filter.selectedStatuses.includes(
                        status.value
                      )
                        ? `#${
                            statuses.find(
                              (e) => e.booking_status_name == status.value
                            ).booking_status_colour
                          }`
                        : `transparent`,
                      borderColor: `#${
                        statuses.find(
                          (e) => e.booking_status_name == status.value
                        ).booking_status_colour
                      }`,
                    }"
                  ></div>
                </div>
              </div>
              <div class="status-text" v-if="statusSelMaximized">
                {{ status.text }}
              </div>
            </div>
            <div class="status-item">
              <div class="status-checkbox select-all">
                <div class="dt-checkbox">
                  <input
                    type="checkbox"
                    :name="'select-all'"
                    :id="'select-all'"
                    :checked="
                      filter.selectedStatuses.length === statusesTT.length
                    "
                    @click="(e) => onSelectAllStatuses(e)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
              <div
                class="status-text select-all-text"
                v-if="statusSelMaximized"
              >
                {{$t('select_all_none')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="filteredCalendarBookingList.months" class="calendar-view-list">
      <CalendarView
        v-for="month of filteredCalendarBookingList.months"
        :key="month.id"
        :selectedDateBox="selectedDateBox"
        :selectedMonth="filter.selectedMonth"
        :bookingArtistList="month.list"
        :showExternalCalendar="filter.showExternalCalendar"
        :externalDates="month.external_dates"
        :statusColorMap="statusColorMap"
        :class="{
          'dt-loading': bookingArtistListLoading,
        }"
        @eventClicked="onCalendarEventClick"
        @eventAdd="onEventAddCalendar"
        @prev_month="previousMonthClick"
        @next_month="nextMonthClick"
      ></CalendarView>
    </div>
    <ModalContainer :modalKey="'addBooking'" :width="'medium'">
      <AddBooking
        :currency="'EUR'"
        @done="onAddBookingDone"
        @cancelled="onAddBookingCancelled"
      />
    </ModalContainer>

    <!-- <template v-if="addBookingModalContainer">
      <v-dialog persistent v-model="addBookingModal" width="762">
        <AddBooking :currency="'EUR'" @done="onAddBookingDone" @cancelled="onAddBookingCancelled" />
      </v-dialog>
    </template>-->
  </div>
</template>

<script>
import CalendarView from "../components/calendar";

import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../store/types";

import Dropdown from "@plugins/dropdown/dropdown";
import InputField from "@plugins/text-field/input-field";

import BookingSidewindow from "../components/booking-sidewindow/booking-sidewindow";
import SendDocumentFiles from "../components/send-doc-files";
import AddBooking from "../components/add-booking";
import { BookingService } from "../services/booking-service";
import { mapActionObject } from "../../../store/global";
import { bookingsActions } from "../store/bookings/actions";
import { EXTERNAL_CALENDAR_DATE } from "../models/booking-artist.model";
import { bookingListCalendarDateTabRoute } from "../router/router";
import { encodeRoute, createMailHref, openNewTab } from "../../../utility";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../dt-plugins/confirmation/confirmation.service";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createModalMixin,
  openModalRoute,
} from "../../../dt-plugins/modal/modal.mixin";
import { last } from "ramda";
import { format } from "date-fns";
import {
  getYearMonthH,
  navigateFromMonthString,
} from "../../../utility/calendar";
import { showError } from "../../../dt-plugins/notification/notification.service";
import { geti18nMontshDate } from './booking-list.vue';

export default {
  components: {
    CalendarView,
    AddBooking,
    ModalContainer,
  },
  data: function () {
    return {
      showExternalCalendar: false,
      selectedDateBox: null,

      statusSelMaximized: false,
      statusSelMaximized: false,
    };
  },
  mixins: [createModalMixin("addBooking")],
  mounted: function () {
    // Set Route on Blank
    if (!this.monthQuery) {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          month: getYearMonthH(new Date()),
        },
      });
    }

    this.fetchList();
  },
  computed: {
    ...mapGetters(storeNS, {
      // filter: "filter",
      filteredBookingArtistList: "filteredCalendarBookingList",
      externalDates: "externalDates",
      statusColorMap: "statusColorMap",
      bookingArtistListLoading: "bookingArtistListLoading",

      artists: "artists",
      artistsTV: "artistsTV",
      staffs: "staffs",
      statuses: "statuses",
      statusesTT: "statusesTT",

      filter: "calendarFilter",
      monthsTV: "calendarMonthsTV",
      filteredCalendarBookingList: "filteredCalendarBookingList",
    }),
    calendarGrid: function () {
      return (
        this.filter.selectedMonths &&
        getCalendarGrid(new Date(this.filter.selectedMonth))
      );
    },
    dropdownItems: function () {
      return [
        { title: this.$t("external_calendar"), value: "external_calendar" },
        {
          title: this.$t("booking_artist_free_dates"),
          value: "booking_artist_free_dates",
        },
        { title: this.$t("booking_request"), value: "booking_request" },
        {
          title: this.$t("booking_request_form_beta"),
          value: "booking_request_form_beta",
        },
        { title: this.$t("available_artists"), value: "available_artists" },
      ];
    },
    monthQuery: function () {
      return this.$route.query.month;
    },
    // i18nMonthsTV: function () {
    //   return this.monthsTV.map((e) => ({
    //     ...e,
    //     text: this.$t(e.text?.split(' ')?.[0]?.toLowerCase()) + ' ' + e.text?.split(' ')?.[1],
    //   }));
    // },
    i18nMonthsTV: function () {
      return geti18nMontshDate(this, this.monthsTV);
    },
  },
  methods: {
    ...mapActionObject(storeNS, bookingsActions),
    fetchList: function () {
      this.updateFilter({
        selectedMonth: this.monthQuery,
      });
      this[ActionTypes.CALENDAR_BOOKING_LIST.FETCH.ALL]();
    },
    onMenuItemClicked: function (item) {
      switch (item.value) {
        case "external_calendar": {
          if (!this.filter.showExternalCalendar) {
            this.updateFilter({
              showExternalCalendar: true,
            });
          } else {
            this.updateFilter({
              showExternalCalendar: false,
            });
          }
          break;
        }
        case "booking_artist_free_dates": {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "free_dates",
            },
          });
          break;
        }
        case "booking_request": {
          openModalRoute(this, "choose_mail_template", {
            type: "booking_request",
          });
          break;
        }
        case "booking_request_form_beta": {
          openNewTab(
            `https://${window.location.hostname}${window.location.pathname}#/main/request`
          );
          break;
        }
        case "available_artists": {
          openModalRoute(this, "available_artists");
          break;
        }
      }
    },
    onCalendarEventClick: async function (event) {
      if (event.booking_status_name === EXTERNAL_CALENDAR_DATE) {
        ConfirmationService.create({
          subject: `External Calendar`,
          body: event.city,
          model: true,
          width: 500,
          results: [
            createConfirmResult({
              value: "Cancel",
            }),
          ],
          completed: (res) => {
            switch (res) {
              case "Cancel": {
                break;
              }
              default: {
              }
            }
          },
        });
      } else {
        const has_permission = await BookingService.has_permission(
          event.calendar_date_id
        );

        if (
          has_permission.user_permission == 0 ||
          has_permission.calendar_date_exists == 0
        ) {
          showError(this.$t("permission_denied"));
          return;
        }

        this.$router.push({
          name: bookingListCalendarDateTabRoute,
          params: { calendar_date_id: event.calendar_date_id, tab: "overview" },
          query: {
            from: encodeRoute(this.$route),
          },
        });
      }

      // this.$router.push({name: bookingCalCalendarDateTabRoute, params: {calendar_date_id: event.calendar_date_id, tab: 'overview'}})
    },
    onEventAddCalendar: function ({ start_date, end_date }) {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: "add_booking",
          start_date,
          end_date,
        },
      });
    },
    onTodayClick: function () {
      const today = new Date();
      this.selectedDateBox = today;

      const year_month = format(today, "YYYY-MM");
      this.gotoMonth(year_month);
    },
    previousMonthClick: function () {
      const currentIndex = this.monthsTV.findIndex(
        (m) => m.value == this.filter.selectedMonth
      );
      if (currentIndex - 1 >= 0) {
        const previousMonth = this.monthsTV[currentIndex - 1];
        console.log(previousMonth);
        this.updateFilter({
          selectedMonth: previousMonth.value,
        });
      } else {
        this.updateFilter({
          prev: true,
          selectedMonth: this.filter.selectedMonth,
        });
        // selectedMonth: navigateFromMonthString(this.filter.selectedMonth, -1),
      }
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          month: this.filter.selectedMonth,
        },
      });
    },
    nextMonthClick: function () {
      const currentIndex = this.monthsTV.findIndex(
        (m) => m.value == this.filter.selectedMonth
      );
      if (currentIndex > -1 && currentIndex + 1 < this.monthsTV.length) {
        const previousMonth = this.monthsTV[currentIndex + 1];
        this.updateFilter({
          selectedMonth: previousMonth.value,
        });
      } else {
        this.updateFilter({
          next: true,
          selectedMonth: this.filter.selectedMonth,
        });
      }

      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          month: this.filter.selectedMonth,
        },
      });
    },
    onAddBookingClicked: function () {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_booking" },
      });
    },
    maximizeSelectionContainer: function () {
      this.statusSelMaximized = true;
    },
    updateFilter: function (payload) {
      console.log("PAYLOAD DROP", payload);
      this[ActionTypes.CALENDAR_FILTER.UPDATE.ALL](payload);
    },
    onDropdownChange: function (name, value) {
      // console.log({ name, value });

      switch (name) {
        case "month": {
          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              month: value.value,
            },
          });
          this.updateFilter({
            selectedMonth: value.value,
          });

          break;
        }
        case "artist": {
          console.log("DROP SELECT VALUE", value);
          this.updateFilter({
            selectedArtists: value.map((e) => e.value),
          });
          break;
        }
        case "status": {
          this.updateFilter({
            selectedStatuses: value.map((e) => e.value),
          });
          break;
        }
        case "Staff": {
          this.updateFilter({
            selectedStaffs: value.map((e) => e.value),
          });
          break;
        }
      }
    },
    minimizeSelectionContainer: function () {
      this.statusSelMaximized = false;
    },
    onStatusSelected: function (e, status) {
      console.log(status, e.target.checked);

      const findStatus = this.filter.selectedStatuses.find(
        (s) => s == status.value
      );
      console.log("Log: findStatus", status, this.filter.selectedStatuses);

      if (e.target.checked) {
        if (!findStatus) {
          this.updateFilter({
            selectedStatuses: [...this.filter.selectedStatuses, status.value],
          });
        }
      } else {
        if (findStatus) {
          this.updateFilter({
            selectedStatuses: this.filter.selectedStatuses.filter(
              (e) => e != findStatus
            ),
          });
        }
      }
    },
    onSelectAllStatuses: function (e) {
      if (e.target.checked) {
        this.updateFilter({
          selectedStatuses: [...this.statusesTT.map((e) => e.value)],
        });
      } else {
        this.updateFilter({
          selectedStatuses: [],
        });
      }
    },
    gotoMonth: function (year_month) {
      const month = this.monthsTV.find((m) => m.value == year_month);

      console.log("Log: month", month);
      if (year_month != this.filter.selectedMonth) {
        this.updateFilter({
          selectedMonth: year_month,
        });
      }
    },
    onAddBookingCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
          start_date: undefined,
          end_date: undefined,
        },
      });
    },
    onAddBookingDone: async function (calendarDateId) {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
      console.log("Log: fetchList");

      await this.fetchList();
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: { calendar_date_id: calendarDateId, tab: "overview" },
        query: {
          from: encodeRoute(this.$route),
        },
      });
    },

    // MARK: Methods
  },
};
</script>

<style lang="scss">
// .booking-calendar{
//   .top-bar {
//     .dropdown {
//       .menu__activator {
//         &.menu__activator--active {
//           .dropdown--main {
//             .dropdown--main__text {
//               span {
//                 color: var(--bc-darkest);
//               }
//             }
//           }
//         }
//         .dropdown--main {
//           .dropdown--main__text {
//             .placeholder {
//               color: var(--sprt-5);
//             }
//           }
//         }
//       }
//     }
//   }
// }
</style>
